<template>
  <div
    class="modal fade"
    id="GodaddyPopUp"
    tabindex="-1"
    role="dialog"
    aria-labelledby="GodaddyPopUpLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-subscription">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>

        <div class="modal-body">
          <form
            id="ema_signup_form"
            action="https://gem.godaddy.com/signups/subscribe/7e095ef4005e46eeab4342fc03170a81"
            accept-charset="UTF-8"
            method="post"
          >
            <h3 style="font-weight: bold">
              ¡Suscríbase para recibir nuestras ofertas y novedades!
            </h3>
            <input name="utf8" type="hidden" value="✓" />
            &nbsp;
            <div class="form-group mimi_field required">
              <input
                id="signup_name"
                class="form-control input-subscription"
                name="signup[name]"
                type="text"
                placeholder="Ingrese su nombre completo"
                v-model="clientName"
                required
              />
            </div>
            <div class="form-group mimi_field required">
              <input
                id="signup_email"
                name="signup[email]"
                type="text"
                placeholder="Dirección de correo electrónico"
                class="form-control input-subscription"
                v-model="emailSuscription"
                required
              />
            </div>
            <div class="form-group mimi_field required">
              <select
                v-model="cboCate"
                id="basicSelect"
                :plain="true"
                class="form-control"
                required
              >
                <option disabled value="">Seleccione Área de interes *</option>
                <option
                  v-for="cate in categories"
                  :key="cate.id_category"
                  :value="cate.id_category"
                  >{{ cate.product_type_desc_es }}</option
                >
              </select>
            </div>

            <div style="background: white; font-size: 1px; height: 0; overflow: hidden">
              <input
                type="text"
                name="390e24f9a78a995bcc312aee2d860935"
                style="
                    font-size: 1px;
                    width: 1px !important;
                    height: 1px !important;
                    border: 0 !important;
                    line-height: 1px !important;
                    padding: 0 0;
                    min-height: 1px !important;
                  "
              />
              <input class="checkbox" type="checkbox" name="beacon" />
            </div>
            &nbsp;
            <div class="mimi_field">
              <input
                type="submit"
                @click="registerClient"
                class="submit btn-al btn-al-lg btn-al-celeste-solid btn-secciones button-left-subscription"
                value="¡SUSCRÍBASE!"
                id="webform_submit_button"
              />
              <button
                type="button"
                class="btn-al btn-al-lg btn-al-rojo-solid btn-secciones button-right-subscription"
                data-dismiss="modal"
              >
                Cerrar</button
              >&nbsp;
            </div>
          </form>

          <br />
          <template v-if="suscriptionProgressBar != false">
            <div class="col-xs-12 text-center">
              <div class="progress">
                <div
                  class="progress-bar progress-bar-striped active"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 100%"
                ></div>
              </div>
            </div>
          </template>

          <div :class="[sucessMessage === '' ? 'd-none' : 'alert alert-success']" role="alert">
            <button type="button" class="close" data-dismiss="alert" @click="ocultar()">
              &times;</button
            ><strong>{{ sucessMessage }}</strong>
          </div>
          <div :class="[errorMessage === '' ? 'd-none' : 'alert alert-danger']" role="alert">
            <button type="button" class="close" data-dismiss="alert" @click="ocultar()">
              &times;</button
            ><strong>{{ errorMessage }}</strong>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { BAD_REQUEST } from '@/types/httpd.constants';
import { postNewSuscription } from '@/service/account.service';
import { getCategories } from '@/service/categories.service';

export default {
  name: 'GodaddyPopUp',
  data() {
    return {
      cboCate: '',
      emailSuscription: '',
      clientName: '',
      sucessMessage: '',
      errorMessage: '',
      suscriptionProgressBar: false,
      categories: [],
    };
  },
  methods: {
    listCategories() {
      getCategories()
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => {});
    },
    resetForm() {
      this.emailSuscription = '';
      this.clientName = '';
    },
    registerClient() {
      if (this.clientName == '' && this.emailSuscription == '') {
        this.errorMessage = 'Coloque su nombre y correo electrónico.';
      } else if (this.clientName == '') {
        this.errorMessage = 'Coloque su nombre';
      } else if (this.emailSuscription == '') {
        this.errorMessage = 'Coloque su correo electrónico';
      } else {
        var validEmail = /.+@.+\..+/;
        if (!validEmail.test(this.emailSuscription)) {
          this.errorMessage = 'Coloque un correo electrónico válido.';
        } else {
          var jsonObject = {
            subscriber_name: this.clientName,
            subscriber_email: this.emailSuscription,
          };

          postNewSuscription(jsonObject)
            .then((response) => {
              this.errorMessage = '';
              this.resetForm();
            })
            .catch((error) => {
              if (error.response.status == BAD_REQUEST) {
                this.resetForm();
              }
            });
          this.suscriptionProgressBar = true;
        }
      }
    },
  },
  created() {
    this.listCategories();
  },
};
</script>

<style></style>
